import styled from 'styled-components';

const FaqItemStyle = styled.div`
	--distanceCategoriesTitle: var(--sp8x);
	--distanceTitlesWrapper: var(--sp4x);
	--distanceAnswer: var(--sp12x);
	--distanceBorder: var(--sp7x);

	.wrapper-categories-title {
		margin-bottom: var(--distanceCategoriesTitle);
	}

	.answer-wrapper {
		margin-top: var(--distanceTitlesWrapper);
	}

	.line {
		margin: var(--distanceBorder) 0;
		border: 1px solid var(--green1000);
		opacity: 0.2;
	}

	.wrapper-all-title-wrapper :last-child {
		.line {
			display: none;
		}

		.answer-wrapper {
			margin-bottom: var(--distanceAnswer);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitlesWrapper: var(--sp3x);
		--distanceAnswer: var(--sp10x);
		--distanceBorder: var(--sp6x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceCategoriesTitle: var(--sp6x);
		--distanceTitlesWrapper: var(--sp2-5x);
		--distanceAnswer: var(--sp7x);
		--distanceBorder: var(--sp5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceCategoriesTitle: var(--sp5x);
		--distanceAnswer: var(--sp6x);
		--distanceBorder: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceCategoriesTitle: var(--sp4x);
		--distanceTitlesWrapper: var(--sp2x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceCategoriesTitle: var(--sp3x);
		--distanceTitlesWrapper: var(--sp1-5x);
		--distanceAnswer: var(--sp5x);
		--distanceBorder: var(--sp2-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--paddingAnswerWrapperTB: var(--sp1-5x);
		--distanceAnswer: var(--sp4x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--paddingAnswerWrapperTB: var(--sp1-5x);
		--distanceTitlesWrapper: var(--sp1x);
	}
`;
export default FaqItemStyle;
